import _ from "lodash";

import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";

const PointsCalculatedCollection = new Mongo.Collection("PointsCalculated", {
    connection: null
});

export class PointCalculated extends CollectionAdapter {
    constructor() {
        super(PointsCalculatedCollection);
    }

    upsert(documents) {
        try {
            if (documents.length) {
                const serieIds = _.uniq(documents.map((doc) => doc.s));
                const scenarios = _.uniq(documents.map((doc) => doc.sc));
                const times = _.uniq(documents.map((doc) => doc.t));
                const periods = _.uniq(documents.map((doc) => doc.period));

                this.deleteMany({
                    sc: { $in: scenarios },
                    s: { $in: serieIds },
                    t: { $in: times },
                    period: { $in: periods }
                });

                this.createMany(documents);
            }
        } catch (error) {
            console.error(error);
        }

        return true;
    }

    createMany(data = []) {
        this._before();

        const total = data.length;

        if (!total) return false;

        for (let i = 0; i < total; i++) {
            const document = data[i];

            //TODO BRENO
            document.sc = document.sc || "ORIGINAL";

            this.create(document);
        }

        return true;
    }
}
